//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { sendCtmEvtLog } from '@/_base/log'
export default {
    props: {
        classname: {
            type: String
        },
        title: {
            type: String
        },
        tabs: {
            type: Array
        }
    },
    methods: {
        clickBtn (e) {
            const { name, url } = e.currentTarget.dataset
            wx.navigateTo({
                url
            })
            sendCtmEvtLog(name)
        }
    }
}
